var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandGAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8283 19.6797V61.0765C51.8283 65.712 55.0232 68.2895 58.4142 68.2895C61.5503 68.2895 65 66.0942 65 61.0765V19.9933C65 15.7498 61.8639 13.0939 58.4142 13.0939C54.9644 13.0939 51.8283 16.0242 51.8283 19.6797Z",
    fill: "#F8AB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5797 40.6917V61.0764C34.5797 65.712 37.7746 68.2895 41.1655 68.2895C44.3016 68.2895 47.7514 66.0942 47.7514 61.0764V41.0053C47.7514 36.7617 44.6153 34.1058 41.1655 34.1058C37.7158 34.1058 34.5797 37.0361 34.5797 40.6917Z",
    fill: "#E37300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5027 61.7037C30.5027 65.3396 27.5528 68.2896 23.9169 68.2896C20.2809 68.2896 17.331 65.3396 17.331 61.7037C17.331 58.0678 20.2809 55.1179 23.9169 55.1179C27.5528 55.1179 30.5027 58.0678 30.5027 61.7037Z",
    fill: "#E37300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandGAnalytics);
export default __webpack_public_path__ + "static/media/Brand-G-Analytics.1ac0a4f9de321775c446807326184e45.svg";
export { ForwardRef as ReactComponent };